import { DeviceRepository } from '@telespot/domain';

export interface IAnyDevicesForDeviceTypeQuery {
  /**
   * Returns true if at least one device references the given device type.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(deviceTypeId: string): Promise<boolean>;
}

export class AnyDevicesForDeviceTypeQuery implements IAnyDevicesForDeviceTypeQuery {
  constructor(private readonly deviceRepository: DeviceRepository) {}

  public async execute(deviceTypeId: string): Promise<boolean> {
    return this.deviceRepository.anyForDeviceType(deviceTypeId);
  }
}
